/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellLogic/ChallengeAuthorities/CardToCardDailyFreeCellAuthority',[
    'SolitaireShared/FreeCellLogic/IDailyFreeCellAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/CardOp',
    'SolitaireShared/CardLogic/MoveState'
], function (IDailyFreeCellAuthority, IDailyAuthority, CardOp, MoveState) {
    "use strict";

    var Key_StackCard = "STACKCARD";
    var Key_BaseCard = "BASECARD";
    var TAG_CARDPLACED = 0x1;

    var CardToCardDailyFreeCellAuthority = function (param) {
        this.initCardToCardDailyFreeCellAuthority(param);
    };

    CardToCardDailyFreeCellAuthority.constructor = CardToCardDailyFreeCellAuthority;
    CardToCardDailyFreeCellAuthority.prototype = Object.create(IDailyFreeCellAuthority.prototype);

    CardToCardDailyFreeCellAuthority.prototype.initCardToCardDailyFreeCellAuthority = function (param) {
        IDailyFreeCellAuthority.call(this, param);

        this.GoalCompleted = false;

        if (param != null && param[Key_StackCard] && param[Key_BaseCard])
        {
            this.StackCard = param[Key_StackCard].toUpperCase();
            this.BaseCard = param[Key_BaseCard].toUpperCase();
        }
        else throw "Invalid parameter passed in creating Daily Challenge";
    };

    Object.defineProperty(CardToCardDailyFreeCellAuthority.prototype, "ChallengeType", {
        get: function () {
            return IDailyAuthority.ChallengeType.CardToCard;
        }
    });

    CardToCardDailyFreeCellAuthority.prototype.Deal = function ()  {
        this.GoalCompleted = false;

        return IDailyFreeCellAuthority.prototype.Deal.call(this);
    };

    CardToCardDailyFreeCellAuthority.prototype.GetScoreForAction = function (action) {
        for (var i = 0; i < action.Ops.length; i++)
        {
            var op = action.Ops[i];
            var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
            if (op.Opcode == CardOp.Op.Move && destPile.Type == "Tableau" && destPile.Count > op.GetNumber(CardOp.eMoveParams.NumCards))
            {
                if (destPile.NthFromTop(op.GetNumber(CardOp.eMoveParams.NumCards)).ToString().Equals(this.StackCard)
                    && destPile.NthFromTop(op.GetNumber(CardOp.eMoveParams.NumCards) + 1).ToString().Equals(this.BaseCard))
                {
                    action.Tag = (action.Tag | TAG_CARDPLACED) >>> 0;
                    break;
                }
            }
        }

        return IDailyFreeCellAuthority.prototype.GetScoreForAction.call(this, action);
    };

    CardToCardDailyFreeCellAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
        if (((tag & TAG_CARDPLACED) >>> 0) != 0)
        {
            this.GoalCompleted = true;
        }

        IDailyFreeCellAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
    };

    CardToCardDailyFreeCellAuthority.prototype.IsGameWon = function () {
        return (!this.CardSupply.WaitingForAnimation) && this.GoalCompleted;
    };

    CardToCardDailyFreeCellAuthority.prototype.CurrentMoveState = function ()
    {
        if (!this.IsGameWon() && IDailyFreeCellAuthority.prototype.IsGameWon.call(this))
            return MoveState.NoMovesLeft;

        return IDailyFreeCellAuthority.prototype.CurrentMoveState.call(this);
    };

    return CardToCardDailyFreeCellAuthority;

});
